import React, {useContext} from "react";
import {RecordsManagementContext} from "../StatesMangement/InitialiseContext";

export default () => {
    let summary = (useContext(RecordsManagementContext).IV3_PageDetails || {}).NcBolSummaryData || {};

    return (
        <div className='ncbol-two-col-row'>
            <div className='ncbol-two-col-left'>
                <span className='ncbol-top-label'>SHIPPER:</span> {summary.shipper || 'N/A'}
            </div>
            <div className='ncbol-two-col-right'>
                <span className='ncbol-top-label'>CONSIGNEE:</span> {summary.consignee || 'N/A'}
            </div>
        </div>
    );
}
